import React, { PropsWithChildren } from "react"

import { H3 } from "~/ui-rtk/components/ui/typography"
import { Dialog } from "~/ui-rtk/components/ui/common"
import { CloseSvg } from "~/ui-rtk/components/ui/svg/essentials"

import { cn } from "~/ui-rtk/utils/tailwind-utils"

export type ConnectorDialogProps = {
  imgSrc: string
  alt: string
  title: string
  isOpen: boolean
  onClose: () => void
  classes?: Partial<{
    container: string
  }>
  // Caps the dialog height and makes the body scroll instead of growing past
  // the window. Off for forms whose content stays short but renders an
  // unportaled floating panel (e.g. GA4's SearchSelect dropdown), since
  // overflow-hidden/overflow-y-auto would clip that panel.
  scrollable?: boolean
} & PropsWithChildren

const ConnectorDialog: React.FC<ConnectorDialogProps> = ({
  imgSrc: img,
  alt,
  title,
  isOpen,
  children,
  classes,
  onClose,
  scrollable = true,
}) => (
  <Dialog isOpen={isOpen} handleClose={onClose}>
    <div
      className={cn(
        "max-w-120 w-full flex flex-col absolute rounded-system-xl p-system-lg center-absolute bg-system-blue-700 border border-basic-blue shadow-deep",
        scrollable && "max-h-[85vh] overflow-hidden",
      )}
    >
      <div className="flex flex-row items-start gap-4 mb-8 shrink-0">
        <img src={img} alt={alt} className="w-9 h-9" />
        <H3 className="font-medium text-white">{title}</H3>
      </div>
      <div
        className={cn(
          "space-y-4",
          scrollable && "overflow-y-auto min-h-0 flex-1",
          classes?.container,
        )}
      >
        {children}
      </div>
      <button
        className="absolute right-4 top-4 max-w-7 max-h-7 p-2 flex items-center justify-center hover:bg-basic-blue hover:text-white transition-colors rounded-1"
        onClick={onClose}
      >
        <CloseSvg size={20} fill="platinum" />
      </button>
    </div>
  </Dialog>
)

export default ConnectorDialog
